import React from "react";

import {
  ISchoolDocumentListItem,
  TManagerSchoolDocumentCategory,
} from "../../../state";
import { delimitize } from "../../../libs/Util";
import {
  MANAGER_SCHOOL_DOCUMENT_CATEGORY,
  MANAGER_SCHOOL_DOCUMENT_TYPE,
} from "../../../Definition";
import { ReactComponent as IconPdf } from "../../../assets/svg/pdf.svg";

import styles from "./SchoolDocumentList.module.scss";

export interface SchoolDocumentListProps {
  documents: ISchoolDocumentListItem[];
  category: TManagerSchoolDocumentCategory;
  calling: boolean;
  error: string;
  onChangeCategory: (category: TManagerSchoolDocumentCategory) => void;
  onDownloadPdf: (documentId: number) => void;
}

const formatIssueMonth = (issueMonth: string) => {
  const [year, month] = issueMonth.split("-");
  return `${year}年${month}月`;
};

export const SchoolDocumentList = (props: SchoolDocumentListProps) => {
  const isReceipt = props.category === "receipt";
  // 納品書（教育・社内発送用）は金額を持たず、target_dateは納品日列に表示済みのため列を出さない
  const isDelivery = props.category === "delivery";
  const categoryLabel = MANAGER_SCHOOL_DOCUMENT_CATEGORY[props.category];

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <p>契約書確認</p>
        <span>発行された契約書の確認・ダウンロードができます。</span>
      </div>
      <div className={styles.headerActions}>
        <select
          aria-label="書類種別"
          className="form-select"
          value={props.category}
          onChange={e =>
            props.onChangeCategory(
              e.currentTarget.value as TManagerSchoolDocumentCategory,
            )
          }
        >
          {Object.entries(MANAGER_SCHOOL_DOCUMENT_CATEGORY).map(
            ([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ),
          )}
        </select>
      </div>
      {props.error && <div className={styles.caution}>{props.error}</div>}
      {props.documents.length === 0 ? (
        <p className={styles.empty}>発行された{categoryLabel}はありません</p>
      ) : (
        <div className={styles.tableWrapper}>
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>発行年月</th>
                <th>書類番号</th>
                <th>種別</th>
                <th>納品日</th>
                {!isDelivery && (
                  <th>{isReceipt ? "領収日" : "お支払い期日"}</th>
                )}
                {!isDelivery && <th className={styles.amount}>金額</th>}
                <th />
              </tr>
            </thead>
            <tbody>
              {props.documents.map(document => (
                <tr key={document.id}>
                  <td>{formatIssueMonth(document.issue_month)}</td>
                  <td>{document.document_no}</td>
                  <td>
                    {MANAGER_SCHOOL_DOCUMENT_TYPE[document.document_type]}
                  </td>
                  <td>{document.delivery_date || "-"}</td>
                  {!isDelivery && <td>{document.target_date}</td>}
                  {!isDelivery && (
                    <td className={styles.amount}>
                      ￥{delimitize(document.total_amount)}
                    </td>
                  )}
                  <td>
                    <button
                      className={styles.pdfButton}
                      aria-label={`${
                        MANAGER_SCHOOL_DOCUMENT_TYPE[document.document_type]
                      }のPDF`}
                      title={
                        MANAGER_SCHOOL_DOCUMENT_TYPE[document.document_type]
                      }
                      disabled={props.calling}
                      onClick={() => props.onDownloadPdf(document.id)}
                    >
                      <IconPdf />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SchoolDocumentList;
